var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInboundCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.568 10.963l-2.179 2.109c-.627-.353-1.83-1.12-3.137-2.428C7.945 9.337 7.17 8.126 6.81 7.492l2.109-2.136L3.594 0 .971 2.606A3.3 3.3 0 00.33 6.377c.933 1.923 2.656 4.824 5.56 7.728 2.905 2.905 5.806 4.628 7.729 5.561.455.221.944.329 1.43.329.857 0 1.705-.335 2.341-.971L20 16.404l-5.432-5.441zm1.716 6.958a1.738 1.738 0 01-1.984.34c-1.815-.88-4.555-2.508-7.306-5.26-2.752-2.75-4.38-5.491-5.26-7.306a1.737 1.737 0 01.34-1.983l1.513-1.504L6.721 5.36 4.925 7.18l.216.487c.036.079.888 1.961 3.007 4.081 2.122 2.121 3.988 2.956 4.067 2.99l.48.211 1.854-1.795 3.246 3.25-1.51 1.517zm1.358-9.908h-5.66v-5.66h1.562v2.994L18.89 0l1.104 1.104-5.347 5.347h2.994v1.562z",
    fill: "url(#inbound-call_svg__paint0_linear_6376_98398)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "inbound-call_svg__paint0_linear_6376_98398",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 19.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1393BC"
  })))));
}

export default __webpack_public_path__ + "./fonts/inbound-call.a68b7a4a8a72a853ea447d9f3ca80bd0.svg";
export { SvgInboundCall as ReactComponent };